const carouselClass = `class Carousel {

    constructCarousel(container, data, cssClass) {
        let mainEl, gallery, carouselWrapper, close, imagesContainer, prev, next, dotContainer,
            detailsContainer;

        mainEl = document.querySelector(container);

        gallery = document.createElement('div');
        gallery.className = 'gallery ' + cssClass;


        carouselWrapper = document.createElement('div');
        carouselWrapper.className = 'carousel';

        close = document.createElement('span');
        close.className = 'close', close.innerHTML = 'X';
        close.addEventListener('click', () => {
            carouselWrapper.style.display = 'none';
            document.getElementsByTagName('body')[0].classList.remove('carousel-active');
        });

        imagesContainer = document.createElement('div');
        imagesContainer.className = 'img-container'

        prev = document.createElement('span');
        prev.className = 'prev', prev.innerHTML = '&#10094;';
        prev.addEventListener('click', () => {
            nextSlide(-1);
        });

        next = document.createElement('span');
        next.className = 'next', next.innerHTML = '&#10095;';
        next.addEventListener('click', () => {
            nextSlide(1);
        });

        detailsContainer = document.createElement('div');
        detailsContainer.className = 'caption-container';

        dotContainer = document.createElement('div');
        dotContainer.className = 'dot-container';

        carouselWrapper.appendChild(close), carouselWrapper.appendChild(imagesContainer), carouselWrapper
            .appendChild(prev), carouselWrapper.appendChild(next), carouselWrapper.appendChild(
                dotContainer),
            carouselWrapper.appendChild(detailsContainer);
        mainEl.appendChild(gallery), mainEl.appendChild(carouselWrapper);



        populateGallery(data)

        function populateGallery(data) {
            if (data.length > 0) {
                let count = 1;
                data.forEach((el) => {
                    let item = document.createElement('div');
                    item.className = 'item';
                    let img = document.createElement('img');
                    img.src = el.image, img.id = count;
                    img.addEventListener('click', () => {
                        activateCarousel(parseInt(img.id));
                    });
                    item.appendChild(img), gallery.appendChild(item);
                    count++;
                });
            }
        }

        createCarousel(data)

        function createCarousel(data) {
            if (data.length > 0) {
                let count = 1;
                data.forEach((el) => {
                    let item = document.createElement('div');

                    item.className = 'img-slide fade';
                    let img = document.createElement('img');
                    img.src = el.image;
                    item.appendChild(img), imagesContainer.appendChild(item);


                    let details = document.createElement('div');
                    details.className = 'caption-item'
                    let number = document.createElement('div');
                    number.className = 'caption-number'
                    number.innerHTML = count + ' of ' + data.length;

                    let caption = document.createElement('div');
                    caption.className = 'caption-msg';
                    if (el.caption) {
                        caption.innerHTML = el.caption;
                    }

                    // create dots
                    let dot = document.createElement('span');
                    dot.className = 'dot', dot.id = count;
                    dot.addEventListener('click', () => {
                        currentSlide('+parseInt(dot.id)+');
                    });
                    dotContainer.appendChild(dot);

                    details.appendChild(number), details.appendChild(caption), detailsContainer
                        .appendChild(details);
                    count++;
                });
            }
        }

        let startIndex = 0;

        function nextSlide(index) {
            activateCarousel(startIndex = parseInt(startIndex) + index);
        }

        function currentSlide(index) {
            activateCarousel(startIndex = index);
        }

        function activateCarousel(index) {
            startIndex = index;
            carouselWrapper.style.display = 'block';

            index > imagesContainer.children.length && (startIndex = 1);
            index < 1 && (startIndex = imagesContainer.children.length);

            for (let i = 0; i < imagesContainer.children.length; i++) {
                imagesContainer.children[i].style.display = 'none';
                detailsContainer.children[i].style.display = 'none';
                dotContainer.children[i].className = dotContainer.children[i].className.replace(' active', '');
            }

            imagesContainer.children[startIndex - 1].style.display = 'block';
            detailsContainer.children[startIndex - 1].style.display = 'block';
            dotContainer.children[startIndex - 1].className += ' active';

            document.getElementsByTagName('body')[0].classList.add('carousel-active');
        }
    }

    _remove(element) {
        const e = document.querySelector(element)
        e.innerHTML = ''
    }
}`

export default carouselClass